<template>
  <div class="googleauth_app">
    <img src="../assets/img/loading.gif" alt="" />
  </div>
</template>

<script>

import {uni} from '../mixin'

export default {
  name: "google_auth_app",
  mixins: [uni],
  methods: {
    getCodeAndToGoogleAuth2Page() {
      const code = this.$route.query.code
      this.uni.postMessage({
        data: {
          action: 'googleAuthSuccess',
          params: {
            code
          }
        }
      })
    }
  },
  mounted() {
    this.getCodeAndToGoogleAuth2Page()
  },
  watch: {
    $route(to) {
      if (to.path === "/google_auth_app") {
        this.getCodeAndToGoogleAuth2Page()
      }
    },
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/public";
</style>



// WEBPACK FOOTER //
// src/view/googleauth_app.vue